import React from "react";
import { css } from "@linaria/core";

export const ScreenReaderSpan: React.FC<{children: React.ReactNode}> = ({ children }) => {
   
    return ( <span className={css`position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;`}>{children}</span>);
}